var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6.66667C12 5.95942 12.281 5.28115 12.781 4.78105C13.2811 4.28095 13.9594 4 14.6667 4H17.3333C18.0406 4 18.7189 4.28095 19.219 4.78105C19.719 5.28115 20 5.95942 20 6.66667V12H25.3333C26.0406 12 26.7189 12.281 27.219 12.781C27.719 13.2811 28 13.9594 28 14.6667V17.3333C28 18.0406 27.719 18.7189 27.219 19.219C26.7189 19.719 26.0406 20 25.3333 20H20V25.3333C20 26.0406 19.719 26.7189 19.219 27.219C18.7189 27.719 18.0406 28 17.3333 28H14.6667C13.9594 28 13.2811 27.719 12.781 27.219C12.281 26.7189 12 26.0406 12 25.3333V20H6.66667C5.95942 20 5.28115 19.719 4.78105 19.219C4.28095 18.7189 4 18.0406 4 17.3333V14.6667C4 13.9594 4.28095 13.2811 4.78105 12.781C5.28115 12.281 5.95942 12 6.66667 12H12V6.66667Z",
    fill: "#15318D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.b3a3645cf0ff6fdb052234a460543f9d.svg";
export { ForwardRef as ReactComponent };